import { useEffect, useState } from "react";
import { getNewSkus } from "../../../services/sku";
import SkusSlider from "../../SkusSlider/SkusSlider";
import classes from "./NewlyAddedSkusSlider.module.css";

const NewlyAddedSkusSlider = () => {
  const [newlyAddedSkus, setNewlyAddedSkus] = useState([]);
  const [isSkusLoading, setIsSkusLoading] = useState(true);

  useEffect(() => {
    const fetchNewlyAddedSkus = async () => {
      try {
        setIsSkusLoading(true);
        const response = await getNewSkus();
        const {
          data: { skuList },
        } = response;
        setNewlyAddedSkus(skuList);
      } catch (err) {
        console.error(err);
      } finally {
        setIsSkusLoading(false);
      }
    };

    fetchNewlyAddedSkus();
  }, []);

  return (
    <SkusSlider
      className={classes["new-skus-slider"]}
      isLoading={isSkusLoading}
      title="منتجات جديدة"
      skus={newlyAddedSkus}
    />
  );
};

export default NewlyAddedSkusSlider;
